import { Grid, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';

import {
  Title,
  TitleProps,
} from 'containers/DataValidationModal/components/Title';

const useStyles = makeStyles<Theme>(theme => ({
  title: {
    marginBottom: 0,
  },
  gridContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0, 2),
  },
}));

export type FileFieldTitleProps = TitleProps & {
  children?: React.ReactNode;
};

export const FileFieldTitle: FC<FileFieldTitleProps> = ({
  children,
  ...props
}) => {
  const styles = useStyles();
  return (
    <Grid item className={styles.gridContent}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Title {...props} className={styles.title} />
        {children}
      </Grid>
    </Grid>
  );
};
